module.exports = __webpack_public_path__ + "static/media/Diverse women 3.aede43c0.jpeg";